import { render, staticRenderFns } from "./ReportCharts.vue?vue&type=template&id=84af0fc8&scoped=true&lang=html&"
import script from "./ReportCharts.vue?vue&type=script&lang=js&"
export * from "./ReportCharts.vue?vue&type=script&lang=js&"
import style0 from "./ReportCharts.vue?vue&type=style&index=0&id=84af0fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84af0fc8",
  null
  
)

export default component.exports